import { BaseSeriesSpecTransformer } from "../base";

export class GaugePointerSeriesSpecTransformer extends BaseSeriesSpecTransformer {
    constructor() {
        super(...arguments), this._supportStack = !1;
    }
}
//# sourceMappingURL=gauge-pointer-transformer.js.map
